import React from 'react';
import { SegmentedControl } from '@colonist/ui';
import styles from './ShareImageSwitcher.module.scss';
/* Segmented control for switching between the share images */ export const ShareImageSwitcher = ({ options, selectedImageId, onSelectImage })=>{
    const hasMultipleImages = options.length > 1;
    if (!hasMultipleImages) return null;
    return /*#__PURE__*/ React.createElement("div", {
        className: styles.imageSwitcher
    }, /*#__PURE__*/ React.createElement(SegmentedControl, {
        options: options,
        activeId: selectedImageId,
        onTabChange: onSelectImage,
        size: "md"
    }));
};
